module.exports = __webpack_public_path__ + "img/map-yellow-bg.eb9d92ed.png";